import RawHtml from '../../../../components/RawHtml';
import { useGetFieldErrors } from '../../state/hooks';
import ErrorMessage from '../ErrorMessage';

interface FieldErrorsProps {
  fallback?: string;
  fieldId: number;
}

const FieldErrors = ({
  fallback,
  fieldId,
}: FieldErrorsProps) => {
  const fieldErrors = useGetFieldErrors(fieldId);

  if (!fieldErrors.length) {
    return null;
  }

  return (
    <div>
      {fieldErrors.map(fieldError => {
        return (
          <ErrorMessage key={fieldError || fallback}>
            <RawHtml>
              {/* message can be an empty string, so we need to use || over ?? */}
              {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
              {fieldError || fallback || ''}
            </RawHtml>
          </ErrorMessage>
        );
      })}
    </div>
  );
};

export default FieldErrors;
